import type { ValidationErrors } from '../../../../utils/validation';
import type { OrthOExaminationOrder } from './orthOExaminationOrder';
import { OrthOV1ProcedureOdOsOdsFindingsRow } from './OrthOV1ProcedureOdOsOdsFindingsRow';

interface IOrthOV1ProcedureOdOsOdsFindingsTableProps {
    errors?: ValidationErrors;
    field: string;
    isReadOnly: boolean;
    label: string;
    tabIndexOd: OrthOExaminationOrder;
    tabIndexOds: OrthOExaminationOrder;
    tabIndexOs: OrthOExaminationOrder;
    value_od?: string | null;
    value_ods?: string | null;
    value_os?: string | null;
}

export function OrthOV1ProcedureOdOsOdsFindingsTable(props: IOrthOV1ProcedureOdOsOdsFindingsTableProps) {
    return <OrthOV1ProcedureOdOsOdsFindingsRow {...props} />;
}
